export const PROTECTED_CARD_GREEN_LIST_PHONES: string[] = [
  '31991628957',
  '31992920908',
  '31999357968',
  '81997199606',
  '91992816221',
]
